import { useEffect } from 'react';
import styled from '@emotion/styled';
import { ITimeOption } from './TimeOption';
import {
	ClockIcon,
	Css,
	DropdownOption,
	ISelectComponent,
	ISelectProps,
	ITheme,
	Select,
	StyledDropdownItem,
} from '../../../ui';

export interface ITimeSelectProps extends ISelectProps<ITimeOption> {
	onChange: (option: ITimeOption | null) => void;
}

export const TimeSelect = (props: ITimeSelectProps) => {
	useValidateSelectedItem(props);

	return <StyledTimeSelect icon={<ClockIcon aria-label="Time" />} {...props} />;
};

const CustomSelect = Select as ISelectComponent<ITimeSelectProps>;

export const StyledTimeSelect = styled(CustomSelect)<{}, ITheme>`
	white-space: nowrap;
	width: ${Css.pxToRem(280)};

	${DropdownOption} {
		:hover {
			background: ${(props) => props.theme.color.primaryLight};
			${StyledDropdownItem} {
				color: ${(props) => props.theme.color.secondary};
			}
		}
	}
`;

function useValidateSelectedItem({
	selectedItem,
	items,
	onChange,
}: ITimeSelectProps) {
	useEffect(() => {
		if (!selectedItem) return;

		const isSelectedItemValid = items.some(
			(item) => item.value === selectedItem.value,
		);

		if (!isSelectedItemValid) {
			onChange(null);
		}
	}, [selectedItem, items]);
}
